import Heading from 'styles/typography/Heading';
import Link from 'components/Globals/Base/Link';
import { ParseHtmlDefault } from 'utils/miscUtils/rawHtml';
import { ARTICLE_PAGE_TEST_IDS } from 'constants/testsIds/articlePage';
import * as S from './ProductCardStyles';

interface ProgramCard {
  title: string;
  table: {
    name: string;
    value: string;
    visible: string;
  }[];
  description: string;
  cta: {
    url: string;
    text: string;
  };
}

const ProgramCard = ({ title, table, description, cta }: ProgramCard) => (
  <S.Wrapper>
    <Heading
      data-cy={ARTICLE_PAGE_TEST_IDS.SCHOOL_PAGE_PROGRAM_CARD_TITLE}
      $fontFamily='graphikCond'
      $size={{ default: 'level3', mdMin: 'level2' }}
    >
      {title}
    </Heading>
    {table && table.length > 0 && (
      <table data-cy={ARTICLE_PAGE_TEST_IDS.SCHOOL_PAGE_PROGRAM_CARD_TABLE}>
        <tbody>
          {table.map(({ name, value, visible }) =>
            visible ? (
              <tr
                data-cy={ARTICLE_PAGE_TEST_IDS.SCHOOL_PAGE_PROGRAM_CARD_TR}
                key={`${name}${value}`}
              >
                <th data-cy={ARTICLE_PAGE_TEST_IDS.SCHOOL_PAGE_PROGRAM_CARD_TH}>{name}</th>
                <td data-cy={ARTICLE_PAGE_TEST_IDS.SCHOOL_PAGE_PROGRAM_CARD_TD}>{value}</td>
              </tr>
            ) : null,
          )}
        </tbody>
      </table>
    )}
    {description && (
      <S.Description data-cy={ARTICLE_PAGE_TEST_IDS.SCHOOL_PAGE_PROGRAM_CARD_SUMMARY}>
        {ParseHtmlDefault(description)}
      </S.Description>
    )}
    {cta.url && cta.text && (
      <Link
        data-cy={ARTICLE_PAGE_TEST_IDS.SCHOOL_PAGE_PROGRAM_CARD_LINK}
        type='primaryBrandButton'
        href={cta.url}
      >
        {cta.text}
      </Link>
    )}
  </S.Wrapper>
);

export default ProgramCard;
